import {
    FETCH_INSIDER_ATTACK_DETAILS,
    FETCH_INSIDER_ATTACK_DETAILS_FAIL,
    FETCH_INSIDER_ATTACK_DETAILS_SUCCESS,
    FETCH_INSIDER_ATTACK_OPTIONS,
    FETCH_INSIDER_ATTACK_OPTIONS_FAIL,
    FETCH_INSIDER_ATTACK_OPTIONS_SUCCESS,
    FETCH_REQUESTED_ATTACKS,
    FETCH_REQUESTED_ATTACKS_FAIL,
    FETCH_REQUESTED_ATTACKS_SUCCESS,
    POST_NEW_REQUESTED_ATTACK,
    POST_NEW_REQUESTED_ATTACK_FAIL,
    POST_NEW_REQUESTED_ATTACK_SUCCESS

} from 'constants/ActionTypes';

/*  jfd*******************************
 *   /get options for AOD
     ********************************** */
export const fetchInsiderAttackOptions = (data) => {
    return {
        type: FETCH_INSIDER_ATTACK_OPTIONS,
        payload: data,
    };
};

export const fetchInsiderAttackOptionsSuccess = (data) => {
    return {
        type: FETCH_INSIDER_ATTACK_OPTIONS_SUCCESS,
        payload: data
    };
};

export const fetchInsiderAttackOptionsFail = (data) => {
    return {
        type: FETCH_INSIDER_ATTACK_OPTIONS_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   /get requested attacks for AOD log
     ********************************** */
export const fetchRequestedAttacks = (data) => {
    return {
        type: FETCH_REQUESTED_ATTACKS,
        payload: data,
    };
};

export const fetchRequestedAttacksSuccess = (data) => {
    return {
        type: FETCH_REQUESTED_ATTACKS_SUCCESS,
        payload: data
    };
};

export const fetchRequestedAttacksFail = (data) => {
    return {
        type: FETCH_REQUESTED_ATTACKS_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   /get details for a single attacks
     ********************************** */
export const fetchRequestedAttackDetails = (data) => {
    return {
        type: FETCH_INSIDER_ATTACK_DETAILS,
        payload: data,
    };
};

export const fetchRequestedAttackDetailsSuccess = (data) => {
    return {
        type: FETCH_INSIDER_ATTACK_DETAILS_SUCCESS,
        payload: data
    };
};

export const fetchRequestedAttackDetailsFail = (data) => {
    return {
        type: FETCH_INSIDER_ATTACK_DETAILS_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   /ADD NEW AoD
     ********************************** */
export const postNewAttackOnDemand = (data) => {
    return {
        type: POST_NEW_REQUESTED_ATTACK,
        payload: data,
    };
};

export const postNewAttackOnDemandSuccess = (data) => {
    return {
        type: POST_NEW_REQUESTED_ATTACK_SUCCESS,
        payload: data
    };
};

export const postNewAttackOnDemandFail = (data) => {
    return {
        type: POST_NEW_REQUESTED_ATTACK_FAIL,
        payload: data
    };
};